<template>
  <div class="page-wrapper">
    <!-- ====================== PC 端 ====================== -->
    <div class="pc-version">
      <div
        class="goods-level-page"
        v-loading="loading"
        element-loading-text="拼命加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.3)"
      >
        <!-- 搜索栏 -->
        <div class="search-bar">
          <el-form :inline="true" :model="queryForm" class="search-form">
            <el-form-item label="商品类型">
              <el-select
                v-model="queryForm.type"
                placeholder="请选择类型"
                clearable
                style="width: 180px"
              >
                <el-option
                  v-for="item in typeOptions"
                  :key="item.type"
                  :label="item.desc"
                  :value="item.type"
                />
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="getList">搜索</el-button>
              <el-button @click="resetQuery">重置</el-button>
            </el-form-item>
          </el-form>
        </div>

        <!-- 表格 -->
        <el-table
          :data="tableData"
          border
          stripe
          header-align="center"
          align="center"
          style="width: 100%; margin-top: 10px"
        >
          <el-table-column label="ID" prop="id" />
          <el-table-column label="等级名称" prop="name" />
          <el-table-column label="等级ID" prop="level_id" />

          <el-table-column label="类型">
            <template slot-scope="scope">
              {{ getTypeText(scope.row.type) }}
            </template>
          </el-table-column>
          <el-table-column label="颜色" prop="color" />
          <el-table-column label="创建时间" prop="created_at" />
          <el-table-column label="更新时间" prop="updated_at" />
        </el-table>

        <!-- 分页 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="text-align: right; margin-top: 20px"
        />
      </div>
    </div>

    <!-- ====================== 移动端（卡片式） ====================== -->
    <div class="mobile-version">
      <div
        class="mobile-goods-level-container"
        v-loading="loading"
        element-loading-text="加载中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0,0,0,0.4)"
      >
        <!-- 移动端搜索 -->
        <div class="mobile-search-group">
          <el-select
            v-model="queryForm.type"
            placeholder="商品类型"
            clearable
            size="medium"
            style="width: 100%"
          >
            <el-option
              v-for="item in typeOptions"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            />
          </el-select>

          <div style="display: flex; gap: 8px; margin-top: 8px">
            <el-button
              type="primary"
              plain
              round
              @click="getList"
              style="flex: 1"
            >
              搜索
            </el-button>
            <el-button plain round @click="resetQuery" style="flex: 1">
              重置
            </el-button>
          </div>
        </div>

        <!-- 移动端卡片列表 -->
        <div class="mobile-card-list">
          <div class="mobile-card" v-for="item in tableData" :key="item.id">
            <div class="card-header">
              <div class="info">
                <div class="title">{{ item.name }}</div>
                <div class="meta">
                  ID:{{ item.id }} | 等级ID:{{ item.level_id }}
                </div>
              </div>
              <div
                class="color-tag"
                :style="{ backgroundColor: item.color }"
              ></div>
            </div>

            <div class="card-body">
              <div>类型：{{ getTypeText(item.type) }}</div>
              <div>创建：{{ item.created_at }}</div>
              <div>更新：{{ item.updated_at }}</div>
            </div>
          </div>
        </div>

        <!-- 移动端分页 -->
        <div style="text-align: center; margin-top: 15px">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="page"
            :page-size="page_size"
            layout="total, prev, pager, next, jumper"
            :total="total"
            pager-count="2"
            small
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/api/api.js";

export default {
  name: "GoodsLevel",
  data() {
    return {
      queryForm: { type: "" },
      page: 1,
      page_size: 10,
      total: 0,
      tableData: [],
      typeOptions: [],
      loading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      const params = {
        page: this.page,
        page_size: this.page_size,
        type: this.queryForm.type,
      };

      api.goods
        .goodsLevel({ params })
        .then((res) => {
          if (res.data.code == 1000) {
            const data = res.data.data;
            this.tableData = data.data;
            this.total = data.total;
            this.typeOptions = data.type;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    resetQuery() {
      this.queryForm.type = "";
      this.page = 1;
      this.page_size = 10;
      this.getList();
    },
    getTypeText(type) {
      const item = this.typeOptions.find((t) => t.type === type);
      return item ? item.desc : "未知";
    },
  },
};
</script>

<style scoped>
/* ====================== PC 原有样式 ====================== */
.goods-level-page {
  padding: 20px;
  height: 100%;
  position: relative;
}
.search-bar {
  background: #f5f7fa;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 15px;
}

/* ====================== 移动端样式 ====================== */
.mobile-goods-level-container {
  padding: 12px;
  box-sizing: border-box;
}
.mobile-search-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 12px;
}
.mobile-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.mobile-card {
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.info {
  flex: 1;
}
.title {
  font-size: 16px;
  font-weight: 500;
}
.meta {
  font-size: 12px;
  color: #999;
  margin-top: 4px;
}
.color-tag {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px solid #eee;
}
.card-body {
  font-size: 13px;
  color: #666;
  line-height: 1.8;
}
</style>




// WEBPACK FOOTER //
// src/pages/goods/goodsLevel.vue